"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserProfileVerificationEnum = void 0;
var UserProfileVerificationEnum;
(function (UserProfileVerificationEnum) {
  /** Профиль, в котором не полные данные */
  UserProfileVerificationEnum[UserProfileVerificationEnum["incomplete"] = 0] = "incomplete";
  /** Полные данные, не отправлен */
  UserProfileVerificationEnum[UserProfileVerificationEnum["not_verified"] = 1] = "not_verified";
  /** Отправлен на верификацию */
  UserProfileVerificationEnum[UserProfileVerificationEnum["sent"] = 2] = "sent";
  /** Одобрен */
  UserProfileVerificationEnum[UserProfileVerificationEnum["approved"] = 3] = "approved";
  /** Отклонён */
  UserProfileVerificationEnum[UserProfileVerificationEnum["declined"] = 4] = "declined";
  /** Внесены изменения в верифицированный профиль */
  UserProfileVerificationEnum[UserProfileVerificationEnum["changed"] = 5] = "changed";
  /** Изменённый профиль повторно отправлен на верификацию */
  UserProfileVerificationEnum[UserProfileVerificationEnum["resent"] = 6] = "resent";
  /** Изменения в профиле отклонены */
  UserProfileVerificationEnum[UserProfileVerificationEnum["redeclined"] = 7] = "redeclined";
})(UserProfileVerificationEnum = exports.UserProfileVerificationEnum || (exports.UserProfileVerificationEnum = {}));
